module.exports = __webpack_public_path__ + "static/media/993902.c244f0ae.png";